import { GET_PORTAL_SETTING_FEATURE } from './index';

export const getPortalSettingFeatureAction = (setting_feature) => ({
    type: GET_PORTAL_SETTING_FEATURE,
    setting_feature
});